import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MessServiceService {
  constructor(private messageService: MessageService) {}

  addSuccess(mess: {
    severity?: string;
    title?: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br',
      severity: mess.severity || 'success',
      summary: mess.title || 'Success',
      detail: mess.detail,
      sticky: mess.sticky === undefined ? false : mess.sticky,
    });
  }

  addWarn(mess: {
    severity: string;
    title: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br-warn',
      severity: mess.severity || 'warn',
      summary: mess.title || 'Warning',
      detail: mess.detail,
      sticky: mess.sticky || true,
    });
  }

  addError(mess: {
    severity?: string;
    title?: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br-error',
      severity: mess.severity || 'error',
      summary: mess.title || 'An error has occurred',
      detail: mess.detail || 'Please try again.',
      sticky: mess.sticky || false,
    });
  }

  clearErrors() {
    this.messageService.clear('br-error');
  }
}
